<app-colored-background [backgroundColor]="'#389CC0'">
  <app-header [progress]="2" [showProgressIndicator]="false" [title]="locale.currentTranslation.accidentDescriptionHeader" [useWhiteFontColor]="true" data-testid="no-processing-header"></app-header>
  <div>
    <div class="base-content-container" style="gap:8px;" data-testid="no-processing-container">
      <div>
        <div class="headline1" style="color: #FFFFFF" data-testid="no-processing-title">
          {{ locale.currentTranslation.noProcessingPossible }}
        </div>
        <div class="text-body1" style="color: #FFFFFF; margin-top: 8px;" data-testid="no-processing-content">
          <div data-testid="message-1">
            {{ locale.currentTranslation.noProcessingPossible1 }}
          </div>
          <div data-testid="message-2">
            {{ locale.currentTranslation.noProcessingPossible2 }}
          </div>
          <div data-testid="message-3">
            {{ locale.currentTranslation.noProcessingPossible3 }}
          </div>
        </div>
      </div>
      <div style="display: flex; justify-content: center; margin-top: auto;" data-testid="illustration-container">
        <img src="assets/img/door.png" class="fullscreen-page-highlight-image" data-testid="door-illustration" alt="No processing possible illustration">
      </div>

    </div>
    <app-finish-box data-testid="finish-box"></app-finish-box>
    <div class="main-button-spacing">
      <button class="main-button" routerLink="/" data-testid="btn-understood" role="button" tabindex="0">{{ locale.currentTranslation.understood }}</button>
    </div>
  </div>

  <app-footer data-testid="no-processing-footer"></app-footer>
</app-colored-background>
